export * from "./effectRenderer.pure";

import "../Shaders/postprocess.vertex";
import "../ShadersWGSL/postprocess.vertex";
